import { render, staticRenderFns } from "./estado.vue?vue&type=template&id=2d56206e"
import script from "./estado.vue?vue&type=script&lang=js"
export * from "./estado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports